"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const pino_1 = __importDefault(require("pino"));
const path_1 = __importDefault(require("path"));
const without_1 = __importDefault(require("lodash/without"));
const padEnd_1 = __importDefault(require("lodash/padEnd"));
const parseBoolean = (value) => {
    switch (value) {
        case 'true':
            return true;
        case 'false':
            return false;
        case undefined:
            return undefined;
        default:
            throw new Error('Invalid boolean value: ${value}');
    }
};
/**
 * Disabled when in browser or when environment variable DISABLE_PRETTY_LOG is set to true.
 */
function isPrettyPrintDisabled() {
    return typeof window === 'object' || (parseBoolean(process.env.DISABLE_PRETTY_LOG) ?? false);
}
function isJestRunning() {
    return process.env.JEST_WORKER_ID !== undefined;
}
const rootLogger = (0, pino_1.default)({
    name: 'rootLogger',
    enabled: !process.env.NOLOG,
    level: process.env.LOG_LEVEL ?? 'info',
    formatters: {
        level: (label) => {
            return { level: label }; // log level as string instead of number
        }
    },
    transport: isPrettyPrintDisabled() ? undefined : {
        target: 'pino-pretty',
        options: {
            colorize: parseBoolean(process.env.LOG_COLORS) ?? true,
            singleLine: true,
            translateTime: 'yyyy-mm-dd"T"HH:MM:ss.l',
            ignore: 'pid,hostname',
            levelFirst: true,
            sync: isJestRunning(),
        },
    },
    browser: {
        asObject: true
    }
});
/**
 * This whole monstrosity exists only because pino in browser environment will not print a log message
 * when invoking `logger.info(undefined, 'msg') instead you need to call `logger.info(msg)`.
 */
function wrappedMethodCall(wrappedPinoMethod) {
    return (msg, metadata) => {
        if (metadata !== undefined) {
            wrappedPinoMethod(metadata, msg);
        }
        else {
            wrappedPinoMethod(msg);
        }
    };
}
class Logger {
    static NAME_LENGTH = 25;
    logger;
    fatal;
    error;
    warn;
    info;
    debug;
    trace;
    constructor(module, contextBindings, defaultLogLevel = 'info', parentLogger = rootLogger) {
        this.logger = parentLogger.child({
            name: Logger.createName(module),
            ...contextBindings
        }, {
            level: process.env.LOG_LEVEL ?? defaultLogLevel
        });
        this.fatal = wrappedMethodCall(this.logger.fatal.bind(this.logger));
        this.error = wrappedMethodCall(this.logger.error.bind(this.logger));
        this.warn = wrappedMethodCall(this.logger.warn.bind(this.logger));
        this.info = wrappedMethodCall(this.logger.info.bind(this.logger));
        this.debug = wrappedMethodCall(this.logger.debug.bind(this.logger));
        this.trace = wrappedMethodCall(this.logger.trace.bind(this.logger));
    }
    static createName(module) {
        const parsedPath = path_1.default.parse(String(module.id));
        let fileId = parsedPath.name;
        if (fileId === 'index') {
            // file with name "foobar/index.ts" -> "foobar"
            const parts = parsedPath.dir.split(path_1.default.sep);
            fileId = parts[parts.length - 1];
        }
        const longName = (0, without_1.default)([process.env.STREAMR_APPLICATION_ID, fileId], undefined).join(':');
        return isPrettyPrintDisabled() ?
            longName : (0, padEnd_1.default)(longName.substring(0, this.NAME_LENGTH), this.NAME_LENGTH, ' ');
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map